export const getColumns = (showCustomerColumns = false) => {
  const columns = [
    {
      Header: "QR Code",
      Footer: "QR Code",
      accessor: "encryptCode",
    },
    {
      Header: "Product Name",
      Footer: "Product Name",
      accessor: "productName",
    },
    {
      Header: "Created Date",
      Footer: "Created Date",
      accessor: "createddate",
    },
    {
      Header: "Scan Date",
      Footer: "Scan Date",
      accessor: "scandate",
    },
    {
      Header: "Scan Action",
      Footer: "Scan Action",
      accessor: "status",
    },
  ];

  if (showCustomerColumns) {
    columns.push({
      Header: "Customer Name",
      Footer: "Customer Name",
      accessor: "customerName",
    });
  }

  return columns;
};
